module.exports = __webpack_public_path__ + "static/assets/2ca979d09b271f95782a44beecd7e94e.png";